import React, { useContext } from 'react';
import { Header } from '@ctsu/react-ctsu-ui';
import { AppContext, getToken } from '@ctsu/loader';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import atoms from 'ctsutheme/components/atoms';
import ProtocolAutoComplete from 'containers/protocol/components/ProtocolAutoComplete';
import { protocolBaseRoutes } from 'routes/appRoutes';
import BurgerMenu from 'components/Menu/BurgerMenu';
import { FasSignOut } from 'assets/icons';
import { TE } from 'appconstants';
import protcolSetupRoutes from 'protocol-setup/routes';
import { useFilteredProtocolSetupRoutes } from 'acess/useCanViewProtocol';

const {
  AppBar,
  Toolbar,
  Tooltip
} = atoms;

const styles = theme => ({
  grow: {
    flexGrow: 2
  },
  active: {
    color: 'white'
  }
});

const ExternalComponent = session => (
  <li>
    <a
      href="https://www.ctsu.org/Master/SimplePage.aspx?ckey=CTSU-PROTOCOL-USER-GUIDE"
      target="_blank"
      rel="noopener noreferrer"
    >
      Help
    </a>
  </li>
);

const LogoutCmp = session => (
  <li className="nav-item" style={{ padding: '0' }}>
    <NavLink
      key="imp"
      to="/logout"
      data-id={`${TE.ID}logout`}
      style={{ paddingRight: '0' }}
    >
      Logout
    </NavLink>
  </li>
);

const HeaderComponent = ({ session }) => {
  const context = useContext(AppContext);
  const { application } = context;
  const filteredRoutes = useFilteredProtocolSetupRoutes([...protocolBaseRoutes, ...protcolSetupRoutes]);
  return (
    <Header
      appName={application.appName}
      displayAppName="Protocol"
      key="protocol.header"
      session={session || null}
      subName=""
      routes={filteredRoutes}
      fnToken={getToken}
      stickyData={null}
      showSummary={false}
      externalComponents={ExternalComponent}
      logout={LogoutCmp}
      coreVersion="v1"
      dbName={application.dbName}
      userPermissions={session && session.userPermissions}
      impersonateContext={context}
      userFirstLast={session && session.userFirstLast}
      username={session && session.username}
      impersonateLevel={session && session.impersonateLevel}
      lastLogin={session && session.lastLogin}
      ctepId={session && session.ctepId}
      pwdExpiryDays={session && session.pwdExpiryDays}
    >
      {session && <div className="auto-complete-cls"><ProtocolAutoComplete /></div>}
    </Header>
  );
};

const StickyHeader = ({ children }) => (
  <AppBar elevation={1} className="app-spacing">
    <Toolbar variant="dense" topnavigation>
      <Grid container spacing={4}>
        <Grid item xs={2} className="protocol-sticky-menu">
          <BurgerMenu routes={protocolBaseRoutes} />
        </Grid>
        <Grid item xs={8} className="protocol-sticky-main">
          {children}
        </Grid>
        <Grid item xs={2} className="protocol-sticky-toolbar">
          <Grid container>
            <Grid item xs={9} className="protocol-sticky-search">
              <ProtocolAutoComplete />
            </Grid>
            <Grid item xs={3} className="protocol-sticky-logout">
              <Tooltip
                tooltipplacementbottom="true"
                title="Logout"
              >
                <NavLink
                  key="imp"
                  to="/logout"
                >
                  <FasSignOut />
                </NavLink>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  </AppBar>
);

export default withStyles(styles)(HeaderComponent);
export { StickyHeader };
